import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { qrcode } from "pure-svg-code";
import { useState, useEffect } from "react";
import { convertSvgToPngBase64 } from "components-base/StackCloth/components/functions";
import VariantLabelPdf from "./VariantLabelPdf";

const VariantLabelModal = ({ open, handleClose, data }) => {
  const [data64, setBase64] = useState(null);

  useEffect(() => {
    if (!open) {
      setBase64(null);
      return;
    }
    if (!data || data.length === 0) {
      setBase64([]);
      return;
    }
    const dataArray = [...data];
    const createQR = async () => {
      for (let i = 0; i < dataArray.length; i++) {
        const item = dataArray[i];
        // El QR contiene el identificador único de la variante (trazabilidad)
        const svgString = qrcode({
          content: `${item.id}`,
          padding: 4,
          width: 256,
          height: 256,
          color: "#000000",
          background: "#ffffff",
          ecl: "M",
        });
        const pngData = await convertSvgToPngBase64(svgString, 200, 200);
        const pngDataUrl = pngData.replace("'", "");
        dataArray[i] = { ...dataArray[i], dataURL: pngDataUrl };
      }
      setBase64(dataArray);
    };
    createQR();
  }, [data, open]);

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <QrCode2Icon sx={{ color: "#fff", fontSize: 22 }} />
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 700,
            color: "#fff",
            fontSize: "1rem",
          }}
        >
          Etiquetas QR — Variantes de insumo
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        {data64 && data64.length > 0 ? (
          <VariantLabelPdf data={data64} />
        ) : data64 && data64.length === 0 ? (
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#9ca3af",
              textAlign: "center",
              py: 6,
            }}
          >
            No hay variantes para imprimir.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              py: 8,
            }}
          >
            <CircularProgress color="primary" size={24} />
            <Typography sx={{ fontFamily: "'Poppins', sans-serif" }}>
              Generando etiquetas QR...
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariantLabelModal;
